




































































































































































































































































































import { Component, Prop, Emit, Watch } from "vue-property-decorator";
import Vue from "vue";
import http from "@/axios/http-common";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import SvcRekonsiliasiObat from "@/services/RekonsiliasiObat";
import { appModule } from "@/store/modules/app";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import moment from "moment";
import { userModule } from "@/store/modules/user";
import CpoTglPemberianModal from "@/components/modal/CpoTglPemberianModal.vue";
import ModalRekonsiliasiAdmisi from "@/components/modal/ModalRekonsiliasiAdmisi.vue";
import RpdDewasaSvc from "@/services/RpdDewasaService";
import {
  pesanTempelRpd,
  samaKodeObat,
  tempelRpdKeAdmisi
} from "@/utils/rekonsiliasiDariRpd";

interface DataRekonsiliasiObat {
  id: number | null;
  register_id: string;
  pasien_rm: string;
  category: string;
  asal_unit_id: string;
  tujuan_unit_id: string;
  user_id: string;
  dokter_id: number | null;
  detail: any[];
}

@Component({
  components: {
    ModalKonfirmasi,
    CpoTglPemberianModal,
    ModalRekonsiliasiAdmisi
  }
})
export default class RekonsiliasiObatCard extends Vue {
  @Prop() readonly register;
  @Prop() readonly rm;
  @Prop() kategori: string;
  @Prop() disabled: string;
  @Prop() loadingRekon: boolean;
  @Prop({ required: true }) rekonsiliasiObat!: DataRekonsiliasiObat;
  @Prop({ required: true }) rekonAdmisi!: DataRekonsiliasiObat;
  @Prop() mode: string;

  listObat = [];
  loadingObat = false;
  searchObat = "";
  listKfa = [];
  loadingKfa = false;
  searchKfa = "";
  saving = false;
  removing = false;
  modalOpenKonfirmasi = false;
  msgConfirm = "";
  loading = false;
  modalCPO = false;
  modalAdmisi = false;
  loadingRpd = false;

  async onSearchObat(keyword: string) {
    if (keyword === null || keyword.length < 3) {
      this.listObat = [];
      return;
    }
    this.loadingObat = true;
    http
      .getDataParam("/referensi/obat/search", {
        params: { term: keyword }
      })
      .then(res => {
        this.listObat = res.data;
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => (this.loadingObat = false));
  }

  async onSearchKfa(keyword: string) {
    if (keyword === null || keyword.length < 3) {
      this.listKfa = [];
      return;
    }
    this.loadingKfa = true;
    http
      .getDataParam("/referensi/kfa/search", {
        params: { term: keyword }
      })
      .then(res => {
        this.listKfa = res.data;
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => (this.loadingKfa = false));
  }

  focusToRegimen(item: any, index: any) {
    if (this.kategori != "admisi") {
      const isExist = this.rekonsiliasiObat.detail.some(
        (d: any, i: number) => d.obat_id === item.id && i !== index
      );
      if (isExist) {
        this.rekonsiliasiObat.detail[index].obat_id = null;
        this.rekonsiliasiObat.detail[index].obat.id = null;
        this.rekonsiliasiObat.detail[index].obat.nama = "";
        alert("Tidak bisa input obat yang sama");
        return;
      }
      this.rekonsiliasiObat.detail[index].obat_id = item.id;
    } else {
      const isExist = this.rekonsiliasiObat.detail.some(
        (d: any, i: number) =>
          String(d.kfa_id) === String(item.id) && i !== index
      );
      if (isExist) {
        this.rekonsiliasiObat.detail[index].kfa_id = null;
        this.rekonsiliasiObat.detail[index].kfa.id = null;
        this.rekonsiliasiObat.detail[index].kfa.nama = "";
        alert("Tidak bisa input obat yang sama");
        return;
      }
      this.rekonsiliasiObat.detail[index].kfa_id = item.id;
    }
    this.$nextTick(() => {
      const ref: any = this.$refs["regimen_" + index];
      const el = ref?.$el?.querySelector("input, textarea");
      el?.focus();
    });
  }

  focusToDibawa(index: any) {
    if (this.kategori != "admisi") {
      this.$nextTick(() => {
        const ref: any = this.$refs["dilanjut_" + index];
        const el = ref?.$el?.querySelector("input, textarea");
        el?.focus();
      });
    } else {
      this.$nextTick(() => {
        const ref: any = this.$refs["dibawa_" + index];
        const el = ref?.$el?.querySelector("input, textarea");
        el?.focus();
      });
    }
  }

  focusToDilanjut(index: any) {
    this.$nextTick(() => {
      const ref: any = this.$refs["dilanjut_" + index];
      const el = ref?.$el?.querySelector("input, textarea");
      el?.focus();
    });
  }

  focusToRegimenRanap(index: any) {
    this.$nextTick(() => {
      const ref: any = this.$refs["regimenranap_" + index];
      const el = ref?.$el?.querySelector("input, textarea");
      el?.focus();
    });
  }

  @Watch("loadingRekon", { immediate: true, deep: true })
  onLoading(val: any[]) {
    if (val) {
      this.loading = true;
      this.rekonsiliasiObat.detail = [];
    } else {
      this.loading = false;
    }
  }

  @Watch("disabled", { immediate: true, deep: true })
  onMode(val: any[]) {
    if (val) {
      this.mode = "view";
    }
  }

  get currentRegister() {
    return RegisterKunjungan.register;
  }

  get sessLogin() {
    return userModule.user;
  }

  get headersRekonsiliasi(): any[] {
    let judulRegimen = "";
    let judulRegimenRanap = "";
    if (this.kategori === "admisi") {
      judulRegimen = "Regimen Sebelumnya";
      judulRegimenRanap = "Regimen Selama Rawat Inap";
    } else if (this.kategori === "transfer") {
      judulRegimen = "Regimen Ruang Rawat Sebelumnya";
      judulRegimenRanap = "Regimen Ruang Rawat Saat Ini";
    } else if (this.kategori === "pulang") {
      judulRegimen = "Regimen Sebelumnya";
      judulRegimenRanap = "Regimen Saat Pulang";
    }
    const base: any = [
      {
        text: judulRegimen,
        value: "regimen",
        width: "180px"
      },
      {
        text: "Obat Dilanjut",
        value: "dilanjut",
        width: "120px"
      },
      {
        text: judulRegimenRanap,
        value: "regimen_ranap",
        width: "220px"
      }
    ];

    if (this.kategori != "admisi") {
      base.splice(0, 0, {
        text: "Nama Obat",
        value: "obat",
        width: "250px"
      });
    }

    if (this.kategori === "admisi") {
      base.splice(1, 0, {
        text: "Obat Dibawa",
        value: "dibawa",
        width: "120px"
      });
      base.splice(0, 0, {
        text: "Nama Obat KFA",
        value: "kfa",
        width: "260px"
      });
    }

    if (this.mode != "view") {
      base.push({
        text: "Aksi",
        value: "aksi",
        width: "80px",
        align: "center",
        sortable: false
      });
    }

    return base;
  }

  toggleMode() {
    if (this.mode === "view") {
      this.mode = "save";
    } else {
      this.mode = "view";
    }
  }

  tambahData() {
    let kat = "";
    if (this.kategori === "admisi") {
      kat = "1";
    } else if (this.kategori === "transfer") {
      kat = "2";
    } else if (this.kategori === "pulang") {
      kat = "3";
    }
    this.rekonsiliasiObat = {
      id: null,
      register_id: this.register,
      pasien_rm: this.rm,
      category: kat,
      asal_unit_id: "",
      tujuan_unit_id: "",
      user_id: null,
      dokter_id: this.currentRegister.dokter.id,
      detail: []
    };
  }

  tambahBaris() {
    const row = {
      id: null,
      regimen_text: "",
      obat_dibawa: "",
      obat_lanjut: "",
      regimen_ranap_text: "",
      kfa_id: null,
      obat_id: null,
      kfa: null,
      obat: null
    };
    this.rekonsiliasiObat.detail.push(row);
    if (this.kategori != "admisi") {
      this.$nextTick(() => {
        const ref: any = this.$refs[
          "obat_" + (this.rekonsiliasiObat.detail.length - 1)
        ];
        const el = ref?.$el?.querySelector("input");
        el?.focus();
      });
    } else {
      this.$nextTick(() => {
        const ref: any = this.$refs[
          "kfa_" + (this.rekonsiliasiObat.detail.length - 1)
        ];
        const el = ref?.$el?.querySelector("input");
        el?.focus();
      });
    }
  }

  cpo() {
    this.modalCPO = true;
  }

  admisi() {
    this.modalAdmisi = true;
  }

  rpd() {
    if (this.loadingRpd) return;
    this.loadingRpd = true;
    RpdDewasaSvc.getByRegister(this.register)
      .then(res => {
        const hasil = tempelRpdKeAdmisi(
          this.rekonsiliasiObat.detail,
          res.data.data
        );
        if (hasil.ditambah + hasil.digabung + hasil.sudahAda) {
          appModule.NoticeDelay(pesanTempelRpd(hasil));
        } else {
          appModule.NoticeDelayAlert(pesanTempelRpd(hasil));
        }
      })
      .catch(() => undefined)
      .finally(() => {
        this.loadingRpd = false;
      });
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY") : null;
  }

  simpanRekonsiliasi() {
    const idx = this.rekonsiliasiObat.detail.length;
    // if (
    //   !this.rekonsiliasiObat.detail[idx - 1].kfa_id ||
    //   !this.rekonsiliasiObat.detail[idx - 1].obat_id
    // ) {
    //   this.rekonsiliasiObat.detail.splice(idx - 1, 1);
    // }

    if (!this.saving) {
      this.saving = true;
      const save = this.rekonsiliasiObat.id
        ? SvcRekonsiliasiObat.update(
            this.rekonsiliasiObat.id,
            this.rekonsiliasiObat
          )
        : SvcRekonsiliasiObat.create(this.rekonsiliasiObat);
      save
        .then(resp => {
          if (resp.status === 1) {
            appModule.NoticeDelay("Berhasil menambahkan Rekonsiliasi Obat");
            this.$emit("reload");
            this.mode = "view";
          } else {
            appModule.sendErrorAlert(resp.message);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  reload() {
    alert("reload");
    this.$emit("reload");
  }

  filterRekon(val) {
    const rekonsiliasi = val.filter(i => i.id === this.rekonsiliasiObat.id);
    this.rekonsiliasiObat = rekonsiliasi[0];
    this.mode = "view";
  }

  batal() {
    SvcRekonsiliasiObat.getByRegister(this.register)
      .then(resp => {
        if (resp.status === 1) {
          console.log("dt", resp.data);
          this.filterRekon(resp.data);
        }
      })
      .finally(() => {});
  }

  konfirmHapus() {
    this.modalOpenKonfirmasi = true;
    this.msgConfirm = "Anda yakin ingin hapus rekonsiliasi obat ini";
  }

  hapus() {
    if (!this.removing) {
      this.removing = true;
      SvcRekonsiliasiObat.destroy(this.rekonsiliasiObat.id)
        .then(resp => {
          if (resp.status === 1) {
            this.modalOpenKonfirmasi = false;
            appModule.NoticeDelay("Berhasil menghapus rekonsiliasi obat");
            this.mode = "view";
            this.$emit("reload");
          } else {
            appModule.sendErrorAlert(resp.message);
          }
        })
        .finally(() => {
          this.removing = false;
        });
    }
  }
  tempelCPO(val) {
    const admisi = this.kategori === "admisi";
    val.forEach(item => {
      // dosis_resep = "<dosis> <frekuensi>" → " " bila CPO tanpa resep
      const dosis = (item.dosis_resep || "").trim() || item.dosis_cpo || "";
      const ada = this.rekonsiliasiObat.detail.find((d: any) =>
        samaKodeObat(d.obat_id, item.id)
      );
      if (ada) {
        if (admisi && !(ada.regimen_ranap_text || "").trim()) {
          ada.regimen_ranap_text = dosis;
        }
        return;
      }
      const row = {
        id: null,
        regimen_text: admisi ? "" : dosis,
        obat_dibawa: "",
        obat_lanjut: "",
        regimen_ranap_text: admisi ? dosis : "",
        kfa_id: null,
        obat_id: item.id,
        kfa: null,
        obat: {
          id: item.id,
          nama: item.nama
        }
      };
      this.rekonsiliasiObat.detail.push(row);
    });
  }
}
